import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import "./Components/Css/LandingPage.css";
import Posdashboard from "./Components/Posdashboard.js";
import ThankYou from "./Components/ThankYou.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivacyPolicy from "./Components/PrivacyPolicy.js";
import RefundPolicy from "./Components/RefundPolicy.js";
import TermsConditions from "./Components/TermsConditions.js";
import ContactUs from "./Components/ContactUs.js";

function App() {
  const NotFoundPage = () => (
    <div>Invalid QR or direct access. Please scan a valid QR code.</div>
  );

  return (
    <>
      <Router>
        <Routes>
          <Route path="qr_menu/:id/:id2" element={<Posdashboard />} />
          <Route path="/" element={<Posdashboard />} />
          <Route path="/Thankyou" element={<ThankYou />} />
          <Route path="/pos" element={<Posdashboard />} />
          <Route path="/contact-us" element={<ContactUs full_name={"Uprestro"} />} />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy full_name={"Uprestro"} />}
          />
          <Route
            path="/refund-policy"
            element={<RefundPolicy full_name={"Uprestro"} />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsConditions full_name={"Uprestro"} />}
          />
          {/* Optional: catch-all route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
